import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { EntityLarkBaseApi } from 'api';

export const initDiscountLarkSheet = createAsyncThunk(
  'EntityLarkBase/initDiscountLarkSheet',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityLarkBaseApi.initDiscountLarkSheet(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const initStockLarkSheet = createAsyncThunk(
  'EntityLarkBase/initStockLarkSheet',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityLarkBaseApi.initStockLarkSheet(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const filterEntityLarkBase = createAsyncThunk(
  'EntityLarkBase/filterEntityLarkBase',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityLarkBaseApi.filter(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const filterEntityLarkBaseForDiscount = createAsyncThunk(
  'EntityLarkBase/filterEntityLarkBaseForDiscount',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityLarkBaseApi.filterDiscount(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityLarkBase = createAsyncThunk(
  'EntityLarkBase/createEntityLarkBase',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityLarkBaseApi.create(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityLarkBaseForDiscount = createAsyncThunk(
  'EntityLarkBase/createEntityLarkBaseForDiscount',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityLarkBaseApi.createForDiscount(body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneEntityLarkBase = createAsyncThunk(
  'EntityLarkBase/findOneEntityLarkBase',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityLarkBaseApi.findOne(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneEntityLarkBaseForDiscount = createAsyncThunk(
  'EntityLarkBase/findOneEntityLarkBaseForDiscount',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityLarkBaseApi.findOneForDiscount(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityLarkBase = createAsyncThunk(
  'EntityLarkBase/updateEntityLarkBase',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityLarkBaseApi.update(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityLarkBaseForDiscount = createAsyncThunk(
  'EntityLarkBase/updateEntityLarkBaseForDiscount',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, body } = params;
      const response = await EntityLarkBaseApi.updateForDiscount(id, body);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteEntityLarkBase = createAsyncThunk(
  'EntityLarkBase/deleteEntityLarkBase',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await EntityLarkBaseApi.remove(id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const checkConnectEntityLarkBase = createAsyncThunk(
  'EntityLarkBase/checkConnectEntityLarkBase',
  async (param: { appID: string; appSecret: string }, { rejectWithValue }) => {
    try {
      const response = await EntityLarkBaseApi.checkConnect(param);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface EntityLarkBaseState {
  tableList: Array<any>;
  isLoaded: boolean;
  savedList: Array<any>;
  reloadFlag: boolean;
  savedPagination: any;
}

const initialState: EntityLarkBaseState = {
  tableList: [],
  isLoaded: false,
  savedList: [],
  reloadFlag: false,
  savedPagination: { current: 1, next: 2, prev: 0, take: 10, total: 0 },
};

const EntityLarkBaseSlice = createSlice({
  name: 'EntityLarkBase',
  initialState,
  reducers: {
    reloadEntityLarkBase(state) {
      state.reloadFlag = !state.reloadFlag;
    },
    updateSavedPaginationEntityLarkBase(state, action) {
      state.savedPagination = action.payload;
    },
    updateSavedListEntityLarkBase(state, action) {
      state.savedList = action.payload;
    },
  },
});

const { actions, reducer: entityLarkBaseReducer } = EntityLarkBaseSlice;

export const {
  reloadEntityLarkBase,
  updateSavedPaginationEntityLarkBase,
  updateSavedListEntityLarkBase,
} = actions;

export default entityLarkBaseReducer;
